module.exports = __webpack_public_path__ + "img/doggy.e216b114.gif";